import React from "react";
import { Link } from "react-router-dom";
import { LogOut, RefreshCw, Sparkles } from "lucide-react";
import { SITE } from "@/lib/site";

export default function AdminHeader({ onRefresh, onLogout }) {
  return (
    <header className="bg-br-black text-white">
      <div className="container-br py-4 flex items-center justify-between">
        <Link to="/" className="flex items-center gap-3" aria-label="Black Ridge Construction">
          <img src={SITE.logo} alt="Black Ridge Construction" className="h-12 w-auto object-contain" />
          <span className="text-xs tracking-[0.3em] text-br-bronze-2 hidden sm:inline">ADMIN</span>
        </Link>
        <div className="flex items-center gap-2 sm:gap-3">
          <Link
            to="/admin/owner"
            data-testid="admin-open-crm"
            className="text-xs uppercase tracking-widest border border-amber-400/60 bg-amber-500/15 text-amber-200 hover:bg-amber-500/25 hover:border-amber-300 hover:text-white px-3 py-1.5 rounded flex items-center gap-2 transition-colors"
            aria-label="Open the v7 CRM workspace"
          >
            <Sparkles size={12} />
            <span className="hidden sm:inline">Open CRM</span>
            <span className="sm:hidden">CRM</span>
          </Link>
          <button onClick={onRefresh} className="text-xs uppercase tracking-widest border border-br-line px-3 py-1.5 rounded hover:border-br-bronze flex items-center gap-2"><RefreshCw size={12}/> <span className="hidden sm:inline">Refresh</span></button>
          <button onClick={onLogout} className="text-xs uppercase tracking-widest text-br-bronze-2 hover:text-white flex items-center gap-1" data-testid="admin-logout"><LogOut size={12}/> <span className="hidden sm:inline">Sign Out</span></button>
        </div>
      </div>
    </header>
  );
}
